import { render, staticRenderFns } from "./SharedPatternProperties.vue?vue&type=template&id=412b56c8&scoped=true"
import script from "./SharedPatternProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedPatternProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SharedPatternProperties.vue?vue&type=style&index=0&id=412b56c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b56c8",
  null
  
)

export default component.exports